<script setup lang="ts">
import { useSessionStore } from '../../../../stores';
import { Session } from '../../../../types/session';
import Fullscreen from '../../../General/Fullscreen.vue';
import StudentQuizPlaying from './StudentQuizPlaying.vue';
import StudentQuizWaiting from './StudentQuizWaiting.vue';

const sessionStore = useSessionStore()
</script>

<template>
    <Fullscreen class="p-3 h-full">
        <StudentQuizWaiting v-if="!sessionStore.practiceQuizState?.[Session.quiz]" />
        <StudentQuizPlaying v-else />
    </Fullscreen>
</template>